module.exports = __webpack_public_path__ + "static/img/nuevos_01.f4a034fe.jpg";